// JS for block-specific behavior only
console.log('res faqs block loaded');

jQuery(document).ready(function($) {
    // Initially hide all faq content
    $('.faq-inner-bottom').hide();

    // When an faq header is clicked
    $('.faq-inner').on('click', function() {
        var $currentAccordion = $(this).closest('.faq-inner');
        var $currentContent = $currentAccordion.find('.faq-inner-bottom');

        // Close all other faqs
        $('.faq-inner-bottom').not($currentContent).slideUp();
        $('.faq-inner').not($currentAccordion).removeClass('active');

        // Toggle current faq
        $currentContent.slideToggle();
        $currentAccordion.toggleClass('active');
    });
});